export default "__VITE_ASSET__DDXrVd9q__"